// show settlement report (aka 'one-off pdf') only to Gino Morena brand and its locations.
// This will be removed and replaced with custom reports when they're ready, which will be available for everyone.
import { get } from 'lodash/fp';

import { activeShop } from '../../../auth/selectors';
import { GME_BRAND_ID } from '../constants';


export const canUserViewSettlementReport = (user, shop) => {
  const brandId = get('brandId', user) || get('brandId', shop);
  return (brandId === GME_BRAND_ID);
};

export const requireSettlementReportAllowed = store => (nextState, replace, callback) => {
  const state = store.getState();
  if (!canUserViewSettlementReport(state.auth.user, activeShop(state))) {
    replace({
      pathname: '/',
      state: { nextPathname: nextState.location.pathname },
    });
  }

  return callback();
};

